import {
  FETCH_AUTOFEED_RUNS_REQUEST,
  FETCH_AUTOFEED_RUNS_SUCCESS,
  FETCH_AUTOFEED_RUNS_ERROR,
  FETCH_AUTOFEED_DETAIL_REQUEST,
  FETCH_AUTOFEED_DETAIL_SUCCESS,
  FETCH_AUTOFEED_DETAIL_ERROR,
  FETCH_AUTOFEED_LINES_REQUEST,
  FETCH_AUTOFEED_LINES_SUCCESS,
  FETCH_AUTOFEED_LINES_ERROR,
  FETCH_IMPORT_REJECTIONS_REQUEST,
  FETCH_IMPORT_REJECTIONS_SUCCESS,
  FETCH_IMPORT_REJECTIONS_ERROR,
} from "../types";

const initialState = {
  runs: [],
  runsLoading: false,
  runsError: null,

  // { run, scenarios: [{ scenarioId, scenarioName, applied, ignored, ignoredByReason }] }
  detail: null,
  detailLoading: false,
  detailError: null,

  // Spring Page: { content, totalElements, number, size, totalPages }
  lines: null,
  linesLoading: false,
  linesError: null,

  // Rejected rows of one import batch, keyed by batch id so the labor and non-labor
  // panels don't overwrite each other.
  rejectionsByBatch: {},
  rejectionsLoading: false,
  rejectionsError: null,
};

export default function autofeedReportsReducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_AUTOFEED_RUNS_REQUEST:
      return { ...state, runsLoading: true, runsError: null };
    case FETCH_AUTOFEED_RUNS_SUCCESS:
      return { ...state, runsLoading: false, runs: action.payload };
    case FETCH_AUTOFEED_RUNS_ERROR:
      return { ...state, runsLoading: false, runsError: action.payload };

    case FETCH_AUTOFEED_DETAIL_REQUEST:
      return { ...state, detailLoading: true, detailError: null };
    case FETCH_AUTOFEED_DETAIL_SUCCESS:
      return { ...state, detailLoading: false, detail: action.payload };
    case FETCH_AUTOFEED_DETAIL_ERROR:
      return { ...state, detailLoading: false, detailError: action.payload };

    case FETCH_AUTOFEED_LINES_REQUEST:
      return { ...state, linesLoading: true, linesError: null };
    case FETCH_AUTOFEED_LINES_SUCCESS:
      return { ...state, linesLoading: false, lines: action.payload };
    case FETCH_AUTOFEED_LINES_ERROR:
      return { ...state, linesLoading: false, linesError: action.payload };

    case FETCH_IMPORT_REJECTIONS_REQUEST:
      return { ...state, rejectionsLoading: true, rejectionsError: null };
    case FETCH_IMPORT_REJECTIONS_SUCCESS:
      return {
        ...state,
        rejectionsLoading: false,
        rejectionsByBatch: {
          ...state.rejectionsByBatch,
          [action.payload.batchId]: action.payload.rows,
        },
      };
    case FETCH_IMPORT_REJECTIONS_ERROR:
      return { ...state, rejectionsLoading: false, rejectionsError: action.payload };

    default:
      return state;
  }
}
